export default class MemoryCache {
  constructor(ttl = 60000) {
    if (import.meta.env.DEV) {
      this.ttl = 1000; // still want to use cache for same request
    } else {
      this.ttl = ttl;
    }

    this._cache = {};
  }

  log(msg) {
    logger.trace({ msg: msg.msg, key: msg.key });
  }

  get(key) {
    if (this._cache.hasOwnProperty(key)) {
      const item = this._cache[key];
      if (item.expiry > +new Date()) {
        this.log({ msg: 'getting cache', key, item });
        return item.value;
      } else {
        this.log({ msg: 'expired cache', key, expiry: item.expiry });
        delete this._cache[key];
      }
    }
  }

  set(key, value) {
    this.log({ msg: 'setting cache', key, value, ttl: this.ttl });
    this._cache[key] = {
      expiry: +new Date() + this.ttl,
      value: value,
    };
  }

  async getOrCreate(key, createFn) {
    const item = this.get(key);
    if (item) {
      return item;
    }
    const value = await createFn();
    if (value) {
      this.set(key, value);
    }
    return value;
  }

  cleanup() {
    this._cache = {};
  }
}
